import { useEffect, useRef } from 'react';
import { useRecoilValue } from 'recoil';
import { useLocation, useNavigate } from 'react-router-dom';
import { organizationAtom } from './atom';
import { Paths } from 'services/navigation/paths';

export const OrganizationChangeListener = () => {
  const organization = useRecoilValue(organizationAtom);
  const prevOrgId = useRef<string | null | undefined>(organization?.id);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Only run on org id change (not on first mount)
    const currentPath = location.pathname;

    if (
      prevOrgId.current !== undefined &&
      organization?.id !== prevOrgId.current &&
      currentPath !== Paths.HOME &&
      !currentPath.includes(Paths.ADMINISTRATOR)
    ) {
      navigate(Paths.HOME, { replace: true });
    }
    prevOrgId.current = organization?.id;
  }, [organization?.id, navigate, location.pathname]);

  return null;
};
